import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUpdateOrganizationTilaajavastuuFetchActive = async (
  projectId,
  organizationChartItemId,
  isTilaajavastuuDocumentsFetchActive
) => {
  const apiPath = `organization-charts/project/${projectId}/organization/${organizationChartItemId}/update-tilaajavastuu-fetch-active`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: { isTilaajavastuuDocumentsFetchActive },
  });

  const response = await axios(signedRequest);

  return response.data;
};
